@import 'styles/mixins';
@import 'styles/variables';

.field {
  @include transition;
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid $grey-10;
  border-radius: 8px;
  overflow: hidden;

  &.focused {
    box-shadow: 0px 0px 0px 2px var(--selected-stroke);
    border-color: var(--selected-stroke);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      border: 1px solid var(--dark-80);
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.fieldInput {
  position: relative;
  flex: 1;
  margin-left: 4px;
}

.fieldLabel {
  @include lg-regular;
  align-self: flex-start;
  color: var(--dark-60);
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 10px 0;
}

.selectorField {
  padding: 2px 12px;
}

.reviewNameInput {
  @include lg-regular;
  color: $grey-90;
  width: 100%;
  background: none;
}

.recipientsSelector {
  flex: 1;
  position: relative;
  width: 100%;

  input {
    @include lg-regular;
    caret-color: var(--selected-stroke);

    [data-autopilot-system-redesign='on'] & {
      caret-color: var(--dark-80);
    }

    &::placeholder {
      @include md-regular;
    }
  }
}

.dueDateField {
  display: flex;
  align-items: center;
  flex: inherit;
  padding: 0;
  position: relative;
  z-index: 1;
}

.dueDatePicker {
  @include lg-regular;
  margin: 0 2px 0 3px;
}

.dueDateLabel {
  @include lg-regular;
  color: $grey-40;
}

.startsOn {
  @include lg-regular;
  color: $grey-90;
}

.endsOn {
  @include lg-regular;
  color: var(--dark-40);
  margin-left: auto;
  margin-right: 12px;

  &.fullWidth {
    margin-left: 0;
    margin-right: 0;
  }
}

.subject,
.message {
  @include lg-regular;
  flex-grow: 1;

  &::placeholder {
    color: $grey-40;
  }
}

.messageField {
  padding: 0;
  align-items: start;
  display: block;

  .toolbar {
    margin: 8px;
  }

  .message {
    color: $grey-90;
    margin: 8px 12px;

    :global(.ProseMirror) {
      min-height: 170px;

      p {
        margin: 8px 0;
      }
    }
  }
}

.message {
  resize: none;

  --prose-input-font-size: 16px;
}
